<template>
  <div class="c-three-column">
    <div class="l-container">
      <h2
        v-if="title"
        class="c-three-column__title"
        :class="titleClass"
      >
        {{ title }}
      </h2>
      <div class="l-grid c-three-column__card-container">
        <template v-for="card in cards">
          <nav-card
            v-if="card.contentType == 'NavItem'"
            :key="card.i"
            v-bind="card"
          />
          <landing-page-card
            v-else-if="card.contentType == 'LandingPageCard'"
            :key="card.i"
            v-bind="card"
            :get-product-function="getProductFunction"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import LandingPageCard from '../card/LandingPageCard.vue';
import NavCard from '../nav/sharedComponents/NavCard.vue'

export default {
  components: { LandingPageCard, NavCard },
  props: {
    title: {
      type: String,
      default: null
    },
    titleTypography: {
      type: String,
      default: "t-heading-3"
    },
    titleAlignment: {
      type: String,
      default: "center"
    },
    titleMarginBottom: {
      type: String,
      default: "x-small"
    },
    titleColor: {
      type: String,
      default: ""
    },
    cards: {
      type: Array,
      default: () => [],
    },
    getProductFunction: {
      type: Function,
      required: true
    },
  },
  computed: {
    titleClass() {
      let results = ['']
      results.push(this.titleTypography);
      if (this.titleColor) {
        results.push(this.titleTypography + '--' + this.titleColor);
      }
      if (this.titleAlignment) {
        results.push("u-text-align-" + this.titleAlignment)
      }
      if (this.titleMarginBottom) {
        results.push("u-margin-bottom-" + this.titleMarginBottom)
      }
      if (this.isMobile) {
        if (this.mobileTextAlignment) {
          results.push("u-text-align-" + this.mobileTextAlignment)
        }
      } else {
        results.push("u-text-align-" + this.textAlignment)
      }
      return results;
    },
  }
};
</script>

<style lang="scss" scoped>
.c-three-column {
  padding: $filter-section-padding;
}
.c-three-column__title {
  padding: 0 rem(20px);
}

.c-three-column__card-container {
  grid-template-columns: 1fr 1fr 1fr;
  @include respond(tab-land) {
    grid-template-columns: 1fr 1fr;
  }
  @include respond(phone) {
    grid-template-columns: 1fr;
  }
}
</style>
